import React, { useState } from "react";
import { apiFetch } from "../utils/wkCommon";
import { getUser } from "../utils/auth";
import { isZh } from "../utils/language";

const API_URL = process.env.REACT_APP_BACKEND_URL;

async function genUniqueCode() {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";

  for (let i = 0; i < 10; i++) {
    const code = Array.from({ length: 4 }, () =>
      chars[Math.floor(Math.random() * chars.length)]
    ).join("").toLowerCase();

    const checkUrl = `/api/song-sharings?filters%5BshareCode%5D%5B$eq%5D=${code}`;
    const res = await apiFetch(checkUrl);

    if (!res?.data?.length) {
      return code; // ✅ unique
    }
  }

  throw new Error("Failed to generate unique code");
}

export default function SongShareDialog({ type, song, file, onClose }) {
  const zh = isZh();
  const user = getUser();

  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  async function handleShare() {
    if (loading) return;
    setLoading(true);

    try {
      const code = await genUniqueCode();
      const expiredAt = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000);

      // ===== cek existing =====
      const checkUrl = `${API_URL}/api/song-sharings?filters%5BshareType%5D%5B$eq%5D=${type}&populate[0]=virtuous_song&populate[1]=song_file`;
      const res = await apiFetch(checkUrl);

      let existing = null;

      const list = res?.data || [];

      existing = list.find(item => {
        if (type === "song") {
          return item.virtuous_song?.documentId === song.documentId;
        } else {
          return item.song_file?.documentId === file.documentId;
        }
      });

      let final;

      if (existing) {
        // UPDATE
        const resp = await apiFetch(`/api/song-sharings/${existing.documentId}`, {
          method: "PUT",
          body: {
            data: {
              expiredAt,
              createdByUserEmail: user?.email
            }
          }
        });

        final = resp.data;
      } else {
        // CREATE
        const resp = await apiFetch(`/api/song-sharings`, {
          method: "POST",
          body: {
            data: {
              shareCode: code,
              expiredAt,
              shareType: type,
              virtuous_song: song?.documentId || null,
              song_file: file?.documentId || null,
              createdByUserEmail: user?.email
            }
          }
        });

        final = resp.data;
      }

      const shareUrl = `https://lienfoyuan.com/ss/${final.shareCode}`;

      setResult({
        url: shareUrl,
        expiredAt: final.expiredAt
      });

    } catch (e) {
      console.error(e);
      alert("Error sharing");
    } finally {
      setLoading(false);
    }
  }

  function copy() {
    navigator.clipboard.writeText(result.url);
  }

  return (
    <div>
      {!result ? (
        <>
          <div style={{ marginBottom: "1rem", lineHeight: 1.5 }}>
            {zh
              ? "分享後，任何擁有連結的人都可以在有效期限內下載檔案。是否繼續？"
              : "Dengan melakukan sharing, semua yang memiliki link dapat mengakses dan download file sampai batas waktu 7 hari. Lanjutkan?"}
          </div>

          <div style={{ display: "flex", gap: 8 }}>
            <button className="btn-secondary" onClick={onClose}>
              {zh ? "取消" : "Cancel"}
            </button>

            <button className="btn-primary" onClick={handleShare}>
              {loading ? "..." : (zh ? "確認分享" : "Ya, Share")}
            </button>
          </div>
        </>
      ) : (
        <>
          <div style={{ marginBottom: 8 }}>
            🔗 {result.url}
          </div>

          <div style={{ fontSize: "0.85rem", color: "#666" }}>
            ⏳ Expired: {new Date(result.expiredAt).toLocaleString()}
          </div>

          <div style={{ marginTop: 12, display: "flex", gap: 8 }}>
            <button className="btn-secondary" onClick={copy}>
              📋 Copy
            </button>

            <button className="btn-primary" onClick={onClose}>
              OK
            </button>
          </div>
        </>
      )}
    </div>
  );
}